// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.display-center[data-v-c946dde6]{\n  margin: 0 auto;\n  text-align: center;\n}\n.skeleton-box[data-v-c946dde6]{\n  width: 80%;\n}\n", ""]);
// Exports
module.exports = exports;
